import Step6 from './Step6-compose';

export default Step6;
